import sharingOptionTypes from 'helpers/enums/activities/sharing/sharingOptionTypes'
import sharingOptionsPayloads from 'helpers/enums/activities/sharing/sharingOptionsPayloads'

function addSharingOptionToSharingOptions(sharingOptions, newShareOption) {
	const newSharingOptionsData = removeAnySharingOptionsByType(sharingOptions.data, newShareOption.type)
	return {
		...sharingOptions,
		data: [
			...newSharingOptionsData,
			newShareOption,
		],
	}
}

function removeSharingOptionFromSharingOptions(sharingOptions, shareOptionToRemove) {
	const findBySharingType = {
		[sharingOptionTypes.SOLUTION]: findShareSolutionIndex,
		[sharingOptionTypes.SUBMISSION]: findShareParticipantSolutionIndex,
	}
	const sharingOptionIndex = findBySharingType[shareOptionToRemove.type](sharingOptions.data, shareOptionToRemove)
	return {
		...sharingOptions,
		data: [
			...sharingOptions.data.slice(0, sharingOptionIndex),
			...sharingOptions.data.slice(sharingOptionIndex + 1),
		],
	}
}

function removeAnySharingOptionsByType(sharingOptions, shareOptionType) {
	return sharingOptions.filter(
		sharingOption => sharingOption.type !== shareOptionType
	)
}

function findShareSolutionIndex(sharingOptionsArray) {
	return sharingOptionsArray.findIndex(
		sharingOption => sharingOption.type === sharingOptionTypes.SOLUTION
	)
}

function findShareParticipantSolutionIndex(sharingOptionsArray, shareOptionToRemove) {
	const payloadKey = sharingOptionsPayloads[sharingOptionTypes.SUBMISSION]
	return sharingOptionsArray.findIndex(
		sharingOption => sharingOption.type === sharingOptionTypes.SUBMISSION
		&& sharingOption[payloadKey].participantUid === shareOptionToRemove[payloadKey].participantUid
	)
}

export {
	addSharingOptionToSharingOptions,
	removeSharingOptionFromSharingOptions,
}
